<template>
    <div class="rate">
        <div :style="{width:rate +'%'}" class="color"></div>
    </div>
</template>
<script>
export default {
    data(){
        return {}
    },
    props:["rate"]
}
</script>
<style lang="css" scoped>
   .rate{
      height: 6px;
      width: 170px;
      display: inline-block;
      background-color: #c6d3ee;
      border-radius:3px;  
      margin: 0 10px;
   }
   .color{
       background: #6267ee;
       height: 6px;
       border-radius: 3px;
   }
</style>


// WEBPACK FOOTER //
// src/components/rate.vue